import normalizeCityName from '@/shared/normalizeCityName';
import {
  FALLBACK_META_DESCRIPTION,
  FALLBACK_DOCUMENT_TITLE,
} from '@/data/constants';
import i18n from '../../src/i18n';

export function setMetaDescription(city) {
  const metaDescription = window.document.querySelector(
    `meta[name="description"`
  );
  let metaDescriptionText = FALLBACK_META_DESCRIPTION;
  const metaDescriptionKey = `meta.description.city_template.${normalizeCityName(
    city
  )}`;
  if (i18n.te(metaDescriptionKey)) {
    metaDescriptionText = i18n.t(metaDescriptionKey);
  }
  metaDescription.content = metaDescriptionText;
}

export function getLaadPaalDocumentTitle(city) {
  const documentTitleKey = `navigation.city_template.html_title.${normalizeCityName(
    city
  )}`;
  let documentTitleText = FALLBACK_DOCUMENT_TITLE;
  if (i18n.te(documentTitleKey)) {
    documentTitleText = i18n.t(documentTitleKey);
  }
  return documentTitleText;
}

export function revertMetaDescription() {
  const metaDescription = window.document.querySelector(
    `meta[name="description"`
  );
  metaDescription.content = FALLBACK_META_DESCRIPTION;
}
